import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';

const BuzzTabs = withStyles((theme) => ({
  root: {
    borderBottom: '1px solid ' + theme.palette.buzzBorder,
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
}))(Tabs);

export default BuzzTabs;
